import React from "react";
import VideoPlayer from "./LeapVideoPlayer";

export default function Leap({
  data,
}: {
  data: {
    edges: {
      node: {
        publicURL: string;
        id: string;
        name: string;
      };
    }[];
  };
}) {
  const videos = data?.edges?.map((el) => el?.node);
  return (
    <div className="h-[80vh] py-8 w-full flex justify-center items-center">
      <VideoPlayer videos={videos.map((el) => el.publicURL)} />
    </div>
  );
}
